import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navigation from '../../../components/feature/Navigation';
import Footer from '../../../components/feature/Footer';

export default function ScienceCurriculumPage() {
  const [courseType, setCourseType] = useState<'middle' | 'high'>('middle');
  const [basicBookIndex, setBasicBookIndex] = useState(0);
  const [supplementBookIndex, setSupplementBookIndex] = useState(0);
  const [middleBasicBookIndex, setMiddleBasicBookIndex] = useState(0);
  const [middleSupplementBookIndex, setMiddleSupplementBookIndex] = useState(0);

  // Set page title and meta tags
  useEffect(() => {
    document.title = '미래인재학원 과학 커리큘럼';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', '미래인재학원의 과학 커리큘럼을 확인하세요. 물리, 화학, 생명과학, 지구과학 전 과목 체계적인 과학 교육을 제공합니다.');
    }
    
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute('content', '미래인재학원 과학 커리큘럼');
    }
    
    const ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) {
      ogDescription.setAttribute('content', '미래인재학원의 과학 커리큘럼을 확인하세요. 물리, 화학, 생명과학, 지구과학 전 과목 체계적인 과학 교육을 제공합니다.');
    }

    // Schema.org Course structured data
    const existingSchema = document.getElementById('schema-science-course');
    if (!existingSchema) {
      const script = document.createElement('script');
      script.id = 'schema-science-course';
      script.type = 'application/ld+json';
      script.textContent = JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Course",
        "name": "미래인재학원 과학 커리큘럼",
        "description": "통합과학, 물리, 화학, 생명과학, 지구과학 전 과목 체계적인 과학 교육 과정. 학교별 맞춤형 수업과 완벽한 수행평가 관리를 제공합니다.",
        "provider": {
          "@type": "EducationalOrganization",
          "name": "미래인재학원",
          "url": "https://eliteoffuture1.com/"
        },
        "educationalLevel": ["중학교", "고등학교"],
        "about": {
          "@type": "Thing",
          "name": "과학"
        },
        "hasCourseInstance": [
          {
            "@type": "CourseInstance",
            "name": "중등 과학 과정",
            "description": "학교별 맞춤형 수업, 시험 대비 4주 추가 수업(주3회), 월간고사, 무한 영상 보강.",
            "courseMode": "onsite",
            "location": {
              "@type": "Place",
              "name": "미래인재학원 (지행, 옥정, 민락 캠퍼스)"
            }
          },
          {
            "@type": "CourseInstance",
            "name": "고등 과학 과정",
            "description": "학교별 맞춤형 수업, 완벽한 수행평가 관리(내신 50%), 시험 대비 4주 추가 수업, 월간고사, 무한 영상 보강.",
            "courseMode": "onsite"
          }
        ]
      });
      document.head.appendChild(script);
    }

    return () => {
      const schemaEl = document.getElementById('schema-science-course');
      if (schemaEl) schemaEl.remove();
    };
  }, []);

  const basicBooks = [
    {
      src: "https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/6eddfc5cbb96195b87b3069a40876eae.png",
      alt: "과학 기본서 교재",
      name: "완자"
    },
    {
      src: "https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/bea07104959fdaf637e2568a5845728a.png",
      alt: "과학 기본서 교재 2",
      name: "본"
    }
  ];

  const supplementBooks = [
    {
      src: "https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/8299de9915794c7840848df57c548866.png",
      alt: "기출pick",
      name: "기출pick"
    },
    {
      src: "https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/8d2c966d5baf246b0a772cd601716744.png",
      alt: "1등급 만들기",
      name: "1등급 만들기"
    },
    {
      src: "https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/37d159fd5ad6750b52c01712e4ee5da9.png",
      alt: "자이스토리",
      name: "자이스토리"
    }
  ];

  // 중등 과학 교재 데이터
  const middleBasicBooks = [
    {
      src: 'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/421988460b7e6be5fc66d61dbaa78df0.png',
      alt: '중등 과학 기본서 1',
      name: '완자'
    },
    {
      src: 'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/2796494607a1e0bb33690ec673959437.png',
      alt: '중등 과학 기본서 2',
      name: '오투'
    }
  ];

  const middleSupplementBooks = [
    {
      src: "https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/81cd884a2793efa834d35f775d6ed599.png",
      alt: "중등 과학 시험기간 보충교재 1",
      name: "체크체크"
    },
    {
      src: "https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/dfac5262d2eddfb217838a393c4abdec.png",
      alt: "중등 과학 시험기간 보충교재 2",
      name: "EBS 뉴런"
    },
    {
      src: "https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/2779ceb7dda0cd62992dc19c720cdf28.png",
      alt: "중등 과학 시험기간 보충교재 3",
      name: "개념풀"
    }
  ];

  return (
    <div className="min-h-screen bg-neutral-950">
      <Navigation currentPage="curriculum" />
      
      {/* Hero Section */}
      <section className="relative pt-20 pb-10 md:pt-32 md:pb-20 bg-gradient-to-br from-gray-900 via-black to-gray-900">
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="inline-block px-4 py-2 bg-blue-500/10 border border-blue-500/30 rounded-full mb-6">
            <span className="text-blue-400 text-sm font-semibold">SCIENCE CURRICULUM</span>
          </div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
            <span className="md:hidden">미래인재학원<br />과학 커리큘럼</span>
            <span className="hidden md:inline">미래인재학원 과학 커리큘럼</span>
          </h1>
        </div>
      </section>

      {/* Course Type Selection */}
      <section className="py-20 bg-gradient-to-b from-white to-blue-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col items-center">
            <div className="flex gap-4 bg-white p-2 rounded-full shadow-lg border border-blue-100">
              <button
                onClick={() => setCourseType('middle')}
                className={`px-10 py-4 rounded-full font-bold text-lg transition-all duration-300 whitespace-nowrap cursor-pointer border-2 ${
                  courseType === 'middle'
                    ? 'bg-blue-600 text-white border-blue-600 shadow-lg'
                    : 'bg-white text-blue-600 border-blue-600 hover:bg-blue-50'
                }`}
              >
                중등과정
              </button>
              <button
                onClick={() => setCourseType('high')}
                className={`px-10 py-4 rounded-full font-bold text-lg transition-all duration-300 whitespace-nowrap cursor-pointer border-2 ${
                  courseType === 'high'
                    ? 'bg-blue-600 text-white border-blue-600 shadow-lg'
                    : 'bg-white text-blue-600 border-blue-600 hover:bg-blue-50'
                }`}
              >
                고등과정
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* 중등과정 Content */}
      {courseType === 'middle' && (
        <>
          {/* 중등과정 특징 섹션 */}
          <section className="py-20 bg-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="text-center mb-16">
                <h2 className="text-4xl font-bold text-gray-900 mb-4">
                  중등 과학 <span className="text-blue-600">수업 특징</span>
                </h2>
              </div>

              <div className="grid md:grid-cols-2 gap-8">
                {/* 시험대비 학교별 맞춤형 수업 */}
                <div className="bg-gradient-to-br from-blue-50 to-white rounded-2xl p-8 border border-blue-100 hover:shadow-xl transition-all">
                  <div className="flex items-center gap-4 mb-6">
                    <div className="w-16 h-16 bg-blue-600 rounded-xl flex items-center justify-center flex-shrink-0">
                      <i className="ri-school-line text-3xl text-white"></i>
                    </div>
                    <h3 className="text-2xl font-bold text-gray-900">
                      <span className="hidden md:inline">시험대비 학교별 맞춤형 수업</span>
                      <span className="md:hidden">시험대비 학교별<br />맞춤형 수업</span>
                    </h3>
                  </div>
                  <p className="text-gray-700 leading-relaxed">
                    중학교 과학시험은 학교마다 진도가 다릅니다. 내신의 핵심은 결국 '우리 학교' 맞춤형 수업에 있습니다.
                  </p>
                </div>

                {/* 시험 대비 4주 추가 수업 */}
                <div className="bg-gradient-to-br from-blue-50 to-white rounded-2xl p-8 border border-blue-100 hover:shadow-xl transition-all">
                  <div className="flex items-center gap-4 mb-6">
                    <div className="w-16 h-16 bg-blue-600 rounded-xl flex items-center justify-center flex-shrink-0">
                      <i className="ri-calendar-check-line text-3xl text-white"></i>
                    </div>
                    <h3 className="text-2xl font-bold text-gray-900">
                      <span className="hidden md:inline">시험 대비 4주 추가 수업</span>
                      <span className="md:hidden">시험 대비<br />4주 추가 수업</span>
                    </h3>
                  </div>
                  <p className="text-gray-700 leading-relaxed">
                    시험 4주 전부터는 주 2회 수업에서, 주 3회 수업으로 전환하여 더욱 밀도 있게 실력을 완성합니다.
                  </p>
                </div>

                {/* 월간고사 */}
                <div className="bg-gradient-to-br from-blue-50 to-white rounded-2xl p-8 border border-blue-100 hover:shadow-xl transition-all">
                  <div className="flex items-center gap-4 mb-6">
                    <div className="w-16 h-16 bg-blue-600 rounded-xl flex items-center justify-center flex-shrink-0">
                      <i className="ri-file-text-line text-3xl text-white"></i>
                    </div>
                    <h3 className="text-2xl font-bold text-gray-900">월간고사</h3>
                  </div>
                  <p className="text-gray-700 leading-relaxed">
                    매월 정기 평가를 통해 취약점을 정밀 진단하고, 빈틈없는 보충 수업으로 실력을 보완합니다.
                  </p>
                </div>

                {/* 무한 영상 보강 */}
                <div className="bg-gradient-to-br from-blue-50 to-white rounded-2xl p-8 border border-blue-100 hover:shadow-xl transition-all">
                  <div className="flex items-center gap-4 mb-6">
                    <div className="w-16 h-16 bg-blue-600 rounded-xl flex items-center justify-center flex-shrink-0">
                      <i className="ri-video-line text-3xl text-white"></i>
                    </div>
                    <h3 className="text-2xl font-bold text-gray-900">무한 영상 보강</h3>
                  </div>
                  <p className="text-gray-700 leading-relaxed">
                    모든 강의는 실시간으로 촬영됩니다. 결석 시에도 현장 강의와 동일한 퀄리티의 영상 보강을 진행합니다. 학생이 집에서 들어오는 영상 보강이 아닌, 학원에 등원하여서 조교 선생님의 지도하에 강의를 듣습니다.
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* 중등 과학 수업 교재 섹션 */}
          <section className="py-20 bg-gray-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="text-center mb-16">
                <h2 className="text-4xl font-bold text-gray-900 mb-4">
                  중등 과학 <span className="text-blue-600">수업 교재</span>
                </h2>
              </div>

              <div className="grid md:grid-cols-2 gap-8">
                {/* 기본서 */}
                <div className="bg-white rounded-2xl p-8 border border-gray-200 shadow-lg">
                  <div className="text-center mb-8">
                    <span className="inline-block px-6 py-3 bg-blue-600 text-white font-bold rounded-full text-lg">
                      기본서
                    </span>
                  </div>
                  {/* 데스크탑: 기존 레이아웃 */}
                  <div className="hidden sm:flex justify-center gap-4">
                    {middleBasicBooks.map((book, idx) => (
                      <div key={idx} className="flex flex-col items-center">
                        <div className="w-36 h-48 sm:w-44 sm:h-60 bg-white rounded-xl overflow-hidden shadow-md border-2 border-gray-200 hover:border-blue-400 transition-all">
                          <img 
                            src={book.src}
                            alt={book.alt}
                            className="w-full h-full object-contain"
                          />
                        </div>
                        <p className="mt-3 text-sm text-gray-700 font-medium text-center">{book.name}</p>
                      </div>
                    ))}
                  </div>
                  {/* 모바일: 슬라이드 레이아웃 */}
                  <div className="sm:hidden">
                    <div className="flex flex-col items-center">
                      <div className="w-44 h-60 bg-white rounded-xl overflow-hidden shadow-md border-2 border-gray-200 transition-all">
                        <img 
                          src={middleBasicBooks[middleBasicBookIndex].src}
                          alt={middleBasicBooks[middleBasicBookIndex].alt}
                          className="w-full h-full object-contain"
                        />
                      </div>
                      <p className="mt-3 text-sm text-gray-700 font-medium text-center">{middleBasicBooks[middleBasicBookIndex].name}</p>
                    </div>
                    <div className="flex justify-center items-center gap-4 mt-4">
                      <button
                        onClick={() => setMiddleBasicBookIndex(prev => prev === 0 ? middleBasicBooks.length - 1 : prev - 1)}
                        className="w-10 h-10 flex items-center justify-center bg-gray-100 rounded-full hover:bg-gray-200 transition-all cursor-pointer"
                      >
                        <i className="ri-arrow-left-s-line text-xl text-gray-600"></i>
                      </button>
                      <div className="flex gap-2">
                        {middleBasicBooks.map((_, idx) => (
                          <button
                            key={idx}
                            onClick={() => setMiddleBasicBookIndex(idx)}
                            className={`w-2.5 h-2.5 rounded-full transition-all cursor-pointer ${
                              idx === middleBasicBookIndex ? 'bg-blue-600' : 'bg-gray-300'
                            }`}
                          />
                        ))}
                      </div>
                      <button
                        onClick={() => setMiddleBasicBookIndex(prev => prev === middleBasicBooks.length - 1 ? 0 : prev + 1)}
                        className="w-10 h-10 flex items-center justify-center bg-gray-100 rounded-full hover:bg-gray-200 transition-all cursor-pointer"
                      >
                        <i className="ri-arrow-right-s-line text-xl text-gray-600"></i>
                      </button>
                    </div>
                  </div>
                </div>

                {/* 시험기간 보충교재 */}
                <div className="bg-white rounded-2xl p-8 border border-gray-200 shadow-lg">
                  <div className="text-center mb-8">
                    <span className="inline-block px-6 py-3 bg-blue-600 text-white font-bold rounded-full text-lg">
                      시험기간 보충교재
                    </span>
                  </div>
                  {/* 데스크탑: 기존 레이아웃 */}
                  <div className="hidden sm:flex justify-center gap-3">
                    {middleSupplementBooks.map((book, idx) => (
                      <div key={idx} className="flex flex-col items-center">
                        <div className="w-28 h-40 sm:w-36 sm:h-48 bg-gray-100 rounded-xl overflow-hidden shadow-md border-2 border-gray-200 hover:border-blue-400 transition-all">
                          <img 
                            src={book.src}
                            alt={book.alt}
                            className="w-full h-full object-cover"
                          />
                        </div>
                        <p className="mt-3 text-sm text-gray-700 font-medium text-center">{book.name}</p>
                      </div>
                    ))}
                  </div>
                  {/* 모바일: 슬라이드 레이아웃 */}
                  <div className="sm:hidden">
                    <div className="flex flex-col items-center">
                      <div className="w-44 h-60 bg-gray-100 rounded-xl overflow-hidden shadow-md border-2 border-gray-200 transition-all">
                        <img 
                          src={middleSupplementBooks[middleSupplementBookIndex].src}
                          alt={middleSupplementBooks[middleSupplementBookIndex].alt}
                          className="w-full h-full object-cover"
                        />
                      </div>
                      <p className="mt-3 text-sm text-gray-700 font-medium text-center">{middleSupplementBooks[middleSupplementBookIndex].name}</p>
                    </div>
                    <div className="flex justify-center items-center gap-4 mt-4">
                      <button
                        onClick={() => setMiddleSupplementBookIndex(prev => prev === 0 ? middleSupplementBooks.length - 1 : prev - 1)}
                        className="w-10 h-10 flex items-center justify-center bg-gray-100 rounded-full hover:bg-gray-200 transition-all cursor-pointer"
                      >
                        <i className="ri-arrow-left-s-line text-xl text-gray-600"></i>
                      </button>
                      <div className="flex gap-2">
                        {middleSupplementBooks.map((_, idx) => (
                          <button
                            key={idx}
                            onClick={() => setMiddleSupplementBookIndex(idx)}
                            className={`w-2.5 h-2.5 rounded-full transition-all cursor-pointer ${
                              idx === middleSupplementBookIndex ? 'bg-blue-600' : 'bg-gray-300'
                            }`}
                          />
                        ))}
                      </div>
                      <button
                        onClick={() => setMiddleSupplementBookIndex(prev => prev === middleSupplementBooks.length - 1 ? 0 : prev + 1)}
                        className="w-10 h-10 flex items-center justify-center bg-gray-100 rounded-full hover:bg-gray-200 transition-all cursor-pointer"
                      >
                        <i className="ri-arrow-right-s-line text-xl text-gray-600"></i>
                      </button>
                    </div>
                  </div>
                  <p className="text-center text-gray-600 mt-6 text-sm">
                    <span className="hidden sm:inline">위의 교재는 시험기간에 문제만 선별해서 풀고 있습니다.</span>
                    <span className="sm:hidden">위의 교재는 시험기간에 문제만 선별해서<br />풀고 있습니다</span>
                  </p>
                </div>
              </div>
            </div>
          </section>
        </>
      )}

      {/* 고등과정 Content */}
      {courseType === 'high' && (
        <>
          {/* 고등과정 특징 섹션 */}
          <section className="py-20 bg-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="text-center mb-16">
                <h2 className="text-4xl font-bold text-gray-900 mb-4">
                  고등 과학 <span className="text-blue-600">수업 특징</span>
                </h2>
              </div>

              <div className="grid md:grid-cols-2 gap-8">
                {/* 학교별 맞춤형 수업 */}
                <div className="bg-gradient-to-br from-blue-50 to-white rounded-2xl p-8 border border-blue-100 hover:shadow-xl transition-all">
                  <div className="flex items-center gap-4 mb-6">
                    <div className="w-16 h-16 bg-blue-600 rounded-xl flex items-center justify-center flex-shrink-0">
                      <i className="ri-school-line text-3xl text-white"></i>
                    </div>
                    <h3 className="text-2xl font-bold text-gray-900">학교별 맞춤형 수업</h3>
                  </div>
                  <p className="text-gray-700 leading-relaxed">
                    과학은 학교마다 진도가 다릅니다. 내신의 핵심은 결국 '우리 학교' 맞춤형 수업에 있습니다.
                  </p>
                </div>

                {/* 완벽한 수행평가 관리 */}
                <div className="bg-gradient-to-br from-blue-50 to-white rounded-2xl p-8 border border-blue-100 hover:shadow-xl transition-all">
                  <div className="flex items-center gap-4 mb-6">
                    <div className="w-16 h-16 bg-blue-600 rounded-xl flex items-center justify-center flex-shrink-0">
                      <i className="ri-file-list-3-line text-3xl text-white"></i>
                    </div>
                    <h3 className="text-2xl font-bold text-gray-900">완벽한 수행평가 관리</h3>
                  </div>
                  <p className="text-gray-700 leading-relaxed">
                    내신 성적의 50%를 좌우하는 수행평가, 1점도 놓치지 않도록 철저하게 밀착 관리합니다.
                  </p>
                </div>

                {/* 시험 대비 4주 추가 수업 */}
                <div className="bg-gradient-to-br from-blue-50 to-white rounded-2xl p-8 border border-blue-100 hover:shadow-xl transition-all">
                  <div className="flex items-center gap-4 mb-6">
                    <div className="w-16 h-16 bg-blue-600 rounded-xl flex items-center justify-center flex-shrink-0">
                      <i className="ri-calendar-check-line text-3xl text-white"></i>
                    </div>
                    <h3 className="text-2xl font-bold text-gray-900">시험 대비 4주 추가 수업</h3>
                  </div>
                  <p className="text-gray-700 leading-relaxed">
                    시험 4주 전부터는 주 2회 수업에서, 주 3회 수업으로 전환하여 더욱 밀도 있게 실력을 완성합니다.
                  </p>
                </div>

                {/* 월간고사 */}
                <div className="bg-gradient-to-br from-blue-50 to-white rounded-2xl p-8 border border-blue-100 hover:shadow-xl transition-all">
                  <div className="flex items-center gap-4 mb-6">
                    <div className="w-16 h-16 bg-blue-600 rounded-xl flex items-center justify-center flex-shrink-0">
                      <i className="ri-file-text-line text-3xl text-white"></i>
                    </div>
                    <h3 className="text-2xl font-bold text-gray-900">월간고사</h3>
                  </div>
                  <p className="text-gray-700 leading-relaxed">
                    매월 정기 평가를 통해 취약점을 정밀 진단하고, 빈틈없는 보충 수업으로 실력을 보완합니다.
                  </p>
                </div>

                {/* 무한 영상 보강 */}
                <div className="bg-gradient-to-br from-blue-50 to-white rounded-2xl p-8 border border-blue-100 hover:shadow-xl transition-all md:col-span-2">
                  <div className="flex items-center gap-4 mb-6">
                    <div className="w-16 h-16 bg-blue-600 rounded-xl flex items-center justify-center flex-shrink-0">
                      <i className="ri-video-line text-3xl text-white"></i>
                    </div>
                    <h3 className="text-2xl font-bold text-gray-900">무한 영상 보강</h3>
                  </div>
                  <p className="text-gray-700 leading-relaxed">
                    모든 강의는 실시간으로 촬영됩니다. 결석 시에도 현장 강의와 동일한 퀄리티의 영상 보강을 진행합니다. 학생이 집에서 들어오는 영상 보강이 아닌, 학원에 등원하여서 조교 선생님의 지도하에 강의를 듣습니다.
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* 고등 과학 수업 교재 섹션 */}
          <section className="py-20 bg-gray-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="text-center mb-16">
                <h2 className="text-4xl font-bold text-gray-900 mb-4">
                  고등 과학 <span className="text-blue-600">수업 교재</span>
                </h2>
              </div>

              <div className="grid md:grid-cols-2 gap-8">
                {/* 기본서 */}
                <div className="bg-white rounded-2xl p-8 border border-gray-200 shadow-lg">
                  <div className="text-center mb-8">
                    <span className="inline-block px-6 py-3 bg-blue-600 text-white font-bold rounded-full text-lg">
                      기본서
                    </span>
                  </div>
                  {/* 데스크탑: 기존 레이아웃 */}
                  <div className="hidden sm:flex justify-center gap-4">
                    <div className="flex flex-col items-center">
                      <div className="w-36 h-48 sm:w-44 sm:h-60 bg-white rounded-xl overflow-hidden shadow-md border-2 border-gray-200 hover:border-blue-400 transition-all">
                        <img 
                          src="https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/6eddfc5cbb96195b87b3069a40876eae.png" 
                          alt="과학 기본서 교재" 
                          className="w-full h-full object-contain"
                        />
                      </div>
                      <p className="mt-3 text-sm text-gray-700 font-medium text-center">완자</p>
                    </div>
                    <div className="flex flex-col items-center">
                      <div className="w-36 h-48 sm:w-44 sm:h-60 bg-white rounded-xl overflow-hidden shadow-md border-2 border-gray-200 hover:border-blue-400 transition-all">
                        <img 
                          src="https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/bea07104959fdaf637e2568a5845728a.png" 
                          alt="과학 기본서 교재 2" 
                          className="w-full h-full object-contain"
                        />
                      </div>
                      <p className="mt-3 text-sm text-gray-700 font-medium text-center">본</p>
                    </div>
                  </div>
                  {/* 모바일: 슬라이드 레이아웃 */}
                  <div className="sm:hidden">
                    <div className="flex flex-col items-center">
                      <div className="w-44 h-60 bg-white rounded-xl overflow-hidden shadow-md border-2 border-gray-200 transition-all">
                        <img 
                          src={basicBooks[basicBookIndex].src}
                          alt={basicBooks[basicBookIndex].alt}
                          className="w-full h-full object-contain"
                        />
                      </div>
                      <p className="mt-3 text-sm text-gray-700 font-medium text-center">{basicBooks[basicBookIndex].name}</p>
                    </div>
                    <div className="flex justify-center items-center gap-4 mt-4">
                      <button
                        onClick={() => setBasicBookIndex(prev => prev === 0 ? basicBooks.length - 1 : prev - 1)}
                        className="w-10 h-10 flex items-center justify-center bg-gray-100 rounded-full hover:bg-gray-200 transition-all cursor-pointer"
                      >
                        <i className="ri-arrow-left-s-line text-xl text-gray-600"></i>
                      </button>
                      <div className="flex gap-2">
                        {basicBooks.map((_, idx) => (
                          <button
                            key={idx}
                            onClick={() => setBasicBookIndex(idx)}
                            className={`w-2.5 h-2.5 rounded-full transition-all cursor-pointer ${
                              idx === basicBookIndex ? 'bg-blue-600' : 'bg-gray-300'
                            }`}
                          />
                        ))}
                      </div>
                      <button
                        onClick={() => setBasicBookIndex(prev => prev === basicBooks.length - 1 ? 0 : prev + 1)}
                        className="w-10 h-10 flex items-center justify-center bg-gray-100 rounded-full hover:bg-gray-200 transition-all cursor-pointer"
                      >
                        <i className="ri-arrow-right-s-line text-xl text-gray-600"></i>
                      </button>
                    </div>
                  </div>
                </div>

                {/* 시험기간 보충교재 */}
                <div className="bg-white rounded-2xl p-8 border border-gray-200 shadow-lg">
                  <div className="text-center mb-8">
                    <span className="inline-block px-6 py-3 bg-blue-600 text-white font-bold rounded-full text-lg">
                      시험기간 보충교재
                    </span>
                  </div>
                  {/* 데스크탑: 기존 레이아웃 */}
                  <div className="hidden sm:flex justify-center gap-3">
                    <div className="flex flex-col items-center">
                      <div className="w-28 h-40 sm:w-36 sm:h-48 bg-gray-100 rounded-xl overflow-hidden shadow-md border-2 border-gray-200 hover:border-blue-400 transition-all">
                        <img 
                          src="https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/8299de9915794c7840848df57c548866.png" 
                          alt="기출pick" 
                          className="w-full h-full object-cover"
                        />
                      </div>
                      <p className="mt-3 text-sm text-gray-700 font-medium text-center">기출pick</p>
                    </div>
                    <div className="flex flex-col items-center">
                      <div className="w-28 h-40 sm:w-36 sm:h-48 bg-gray-100 rounded-xl overflow-hidden shadow-md border-2 border-gray-200 hover:border-blue-400 transition-all">
                        <img 
                          src="https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/8d2c966d5baf246b0a772cd601716744.png" 
                          alt="1등급 만들기" 
                          className="w-full h-full object-cover"
                        />
                      </div>
                      <p className="mt-3 text-sm text-gray-700 font-medium text-center">1등급 만들기</p>
                    </div>
                    <div className="flex flex-col items-center">
                      <div className="w-28 h-40 sm:w-36 sm:h-48 bg-gray-100 rounded-xl overflow-hidden shadow-md border-2 border-gray-200 hover:border-blue-400 transition-all">
                        <img 
                          src="https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/37d159fd5ad6750b52c01712e4ee5da9.png" 
                          alt="자이스토리" 
                          className="w-full h-full object-cover"
                        />
                      </div>
                      <p className="mt-3 text-sm text-gray-700 font-medium text-center">자이스토리</p>
                    </div>
                  </div>
                  {/* 모바일: 슬라이드 레이아웃 */}
                  <div className="sm:hidden">
                    <div className="flex flex-col items-center">
                      <div className="w-44 h-60 bg-gray-100 rounded-xl overflow-hidden shadow-md border-2 border-gray-200 transition-all">
                        <img 
                          src={supplementBooks[supplementBookIndex].src}
                          alt={supplementBooks[supplementBookIndex].alt}
                          className="w-full h-full object-cover"
                        />
                      </div>
                      <p className="mt-3 text-sm text-gray-700 font-medium text-center">{supplementBooks[supplementBookIndex].name}</p>
                    </div>
                    <div className="flex justify-center items-center gap-4 mt-4">
                      <button
                        onClick={() => setSupplementBookIndex(prev => prev === 0 ? supplementBooks.length - 1 : prev - 1)}
                        className="w-10 h-10 flex items-center justify-center bg-gray-100 rounded-full hover:bg-gray-200 transition-all cursor-pointer"
                      >
                        <i className="ri-arrow-left-s-line text-xl text-gray-600"></i>
                      </button>
                      <div className="flex gap-2">
                        {supplementBooks.map((_, idx) => (
                          <button
                            key={idx}
                            onClick={() => setSupplementBookIndex(idx)}
                            className={`w-2.5 h-2.5 rounded-full transition-all cursor-pointer ${
                              idx === supplementBookIndex ? 'bg-blue-600' : 'bg-gray-300'
                            }`}
                          />
                        ))}
                      </div>
                      <button
                        onClick={() => setSupplementBookIndex(prev => prev === supplementBooks.length - 1 ? 0 : prev + 1)}
                        className="w-10 h-10 flex items-center justify-center bg-gray-100 rounded-full hover:bg-gray-200 transition-all cursor-pointer"
                      >
                        <i className="ri-arrow-right-s-line text-xl text-gray-600"></i>
                      </button>
                    </div>
                  </div>
                  <p className="text-center text-gray-600 mt-6 text-sm">
                    <span className="hidden sm:inline">위의 교재는 시험기간에 문제만 선별해서 풀고 있습니다</span>
                    <span className="sm:hidden">위의 교재는 시험기간에 문제만 선별해서<br />풀고 있습니다</span>
                  </p>
                </div>
              </div>
            </div>
          </section>
        </>
      )}

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-gray-900 via-black to-gray-900">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-white mb-6">
            과학 실력 향상의 시작
          </h2>
          <p className="text-xl text-gray-300 mb-10 leading-relaxed">
            체계적인 커리큘럼과 전문 강사진이 <br className="md:hidden" />
            함께합니다
          </p>
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 px-10 py-4 bg-amber-400 text-black text-lg font-bold rounded-full hover:bg-amber-300 transition-all shadow-xl shadow-amber-400/20 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-calendar-check-line text-xl"></i>
            입학상담
          </Link>
        </div>
      </section>

      {/* Footer */}
      <Footer />
    </div>
  );
}
